module.exports = __webpack_public_path__ + "f665b26f8bc2e89b602ab4257c80de0e.png";